var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"wrapper",class:{ absolute: _vm.absolute }},[_c('span',{staticClass:"led",class:`status-${_vm.status}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }